const QuestionnaireClassificationType = Object.freeze({
  PreTest: 1,
  PostTest: 2,
  Exam: 3,
});
export default QuestionnaireClassificationType;
